const key = Symbol();

export { key };
